import { useQueryParams } from '@shared/hooks'
import { AnyObject } from 'antd/lib/_util/type'
import { default as queryString, ParsedQuery } from 'query-string'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useQueryUpdateCrm = () => {
  const push = useNavigate()
  const location = useLocation()
  const params = useQueryParams()

  const updateQuery = useCallback(
    (filters: ParsedQuery | AnyObject, reset = false) => {
      const { pathname, search, hash } = location
      const parsedSearchQuery = queryString.parse(search)

      const query = reset ? filters : { ...parsedSearchQuery, ...filters }

      const pushURL = queryString.stringifyUrl(
        {
          url: pathname + hash,
          query
        },
        {
          skipEmptyString: true,
          skipNull: true,
          arrayFormat: 'comma'
        }
      )

      if (pathname + search + hash !== pushURL.replace(/\?+$/g, '')) {
        push(pushURL)
      }
    },
    [push, location]
  )

  return { params, updateQuery }
}
